import { HttpClient, HttpEvent } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {forkJoin, Observable } from 'rxjs';

import { ConfigService } from './config.service';
import { EnergyPerformanceCertificate } from '../models/energy-performance-certificate/energy-performance-certificate';
import { EnergyPerformanceCertificatePost } from '../models/energy-performance-certificate/energy-performance-certificate-post';
import { EnergyPerformanceCertificateOverview } from '../models/energy-performance-certificate/energy-performance-certificate-overview';
import { FileService } from "./file.service";
import { OwnerEnergyPerformanceCertificateOverview } from '../models/energy-performance-certificate/owner-energy-performance-certificate-overview';
import {PropertyServicesSummary} from "../models/property-services/property-services-summary.interface";
import {mergeMap, tap} from "rxjs/operators";
import {GasSafetyCertificate} from "../models/gas-safety-certificate/gas-safety-certificate";
import {BoilerService} from "../models/boiler-service/boiler-service";

@Injectable()
export class EnergyPerformanceCertificateService {
    constructor(private http: HttpClient, private configService: ConfigService, private fileService: FileService) {
    }

    getOverview(propertyReference: string): Observable<EnergyPerformanceCertificateOverview> {
        return this.http.get<EnergyPerformanceCertificateOverview>(`${ this.configService.baseUrl }/manage/property/${ propertyReference }/energy-performance-certificate/overview`);
    }

    getSummary(propertyReference: string): Observable<any> {
        return this.http.get<PropertyServicesSummary>(`${this.configService.baseUrl}/manage/property/${ propertyReference }/energy-performance-certificate/summary`);
    }

    getList(propertyReference: string): Observable<EnergyPerformanceCertificate[]> {
        return this.http.get<EnergyPerformanceCertificate[]>(`${ this.configService.baseUrl }/manage/property/${ propertyReference }/energy-performance-certificate`);
    }

    getOwnerOverview(propertyReference: string): Observable<OwnerEnergyPerformanceCertificateOverview> {
        return this.http.get<OwnerEnergyPerformanceCertificateOverview>(`${this.configService.baseUrl}/owner/property/${propertyReference}/energy-performance-certificate/overview`);
    }

    getOwnerList(propertyReference: string): Observable<EnergyPerformanceCertificate[]> {
        return this.http.get<EnergyPerformanceCertificate[]>(`${this.configService.baseUrl}/owner/property/${propertyReference}/energy-performance-certificate`);
    }

    get(organisationReference: string, guid: string) {
        return this.http.get<EnergyPerformanceCertificate>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/energy-performance-certificate/${guid}`);
    }

    add(organisationReference: string, model: EnergyPerformanceCertificatePost): Observable<EnergyPerformanceCertificate> {
        return forkJoin(
            this.fileService.uploadFiles(model.publicFiles),
            this.fileService.uploadFiles(model.privateFiles)
        ).pipe(
            tap(_ => model.publicFiles = this.fileService.prepareFilePosts(model.publicFiles)),
            tap(_ => model.privateFiles = this.fileService.prepareFilePosts(model.privateFiles)),
            mergeMap(_ => this.http.post<EnergyPerformanceCertificate>(`${this.configService.baseUrl}/manage/organisation/${organisationReference}/energy-performance-certificate`, model))
        );
    }

    remove(propertyReference: string, item: EnergyPerformanceCertificate): Observable<boolean> {
        return this.http.delete<boolean>(`${ this.configService.baseUrl }/manage/property/${ propertyReference }/energy-performance-certificate/${ item.guid }`);
    }

    getOwnerEnergyPerformanceCertificate(propertyReference: string, guid: string): Observable<EnergyPerformanceCertificate> {
        return this.http.get<EnergyPerformanceCertificate>(`${this.configService.baseUrl}/owner/property/${propertyReference}/energy-performance-certificate/${guid}`);
    }
}
